import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import Pricing from "@/pages/Pricing";
export const Route = createFileRoute("/pricing")({ head: ({match}) => pageHead(match.pathname), component: () => (<Pricing />) });
